<mat-form-field>
  <mat-select [formControl]="formControl"
              placeholder="Choose">

    <ngx-mat-select-search
      [formControl]="searchInputControl"
      [placeholderLabel]="'LEAD_GENERATION.SHARED.SEARCH' | translate"
      [noEntriesFoundLabel]="'LEAD_GENERATION.SHARED.NO_RESULT' | translate"
      clearSearchInput="true"></ngx-mat-select-search>

    <mat-option *ngFor="let elem of filteredElements | async" [value]="elem">

      <div class="w-full over-hide text-ellipsis d-flex align-item-center">
        <span  class="pull-left p-l-1">{{elem}}</span>
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
